var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import View from "@core/views";
import Toast from "@core/components/Toast";
var OrderDetailView = /** @class */ (function (_super) {
    __extends(OrderDetailView, _super);
    function OrderDetailView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get Order transactions and populate tab.
     */
    OrderDetailView.prototype.getOrderTransactions = function (orderId) {
        var data = { object_id: orderId, object_type: 'order' };
        this.app.api.private('get_object_transactions', {
            data: data
        }).then(function (response) {
            var transactionTab = document.getElementById('transaction-tab');
            transactionTab.innerHTML = '';
            if (response.transactions.length == 0) {
                var html = '<div class="has-text-centered has-text-muted">No transactions</div>';
                transactionTab.innerHTML += html;
            }
            for (var i = 0; i < response.transactions.length; i++) {
                var html = "\n                    <article class=\"media tc-transaction tc-{{type}}\">\n                        <figure class=\"media-left\">\n                            <div class=\"tc-transaction-icon\">\n                               <i class=\"{{icon_class}}\"></i>\n                            </div>\n                        </figure>\n                        <div class=\"media-content\">\n                            <div class=\"content\">\n                                <strong>{{display_name}}</strong>\n                                &nbsp;<time class=\"is-pulled-right\" datetime=\"{{action_time}}\" >{{action_time_natural}}</time>\n                                <br />\n                                <section class=\"tc-transaction-details\">\n                                    {{details}}\n                                </section>\n                            </div>\n                        </div>\n                    </article>\n                ";
                html = html.replace('{{type}}', response.transactions[i].type)
                    .replace('{{icon_class}}', response.transactions[i].icon_class)
                    .replace('{{display_name}}', response.transactions[i].display_name)
                    .replace('{{action_time}}', response.transactions[i].action_time)
                    .replace('{{action_time_natural}}', response.transactions[i].action_time_natural)
                    .replace('{{details}}', response.transactions[i].details);
                transactionTab.innerHTML += html;
            }
        }, function (error) {
            if (error.serverError) {
                Toast.error(error.serverError.error);
            }
            else {
                Toast.error(django.gettext('Unable to load Order transactions'));
            }
        });
    };
    /**
     * OnClick-listener for "Receive all"-button
     * @param buttonElement
     */
    OrderDetailView.prototype.onReceiveButtonClick = function (buttonElement) {
        buttonElement.disabled = true;
        buttonElement.classList.add('is-loading');
        var uid = buttonElement.getAttribute('data-uid');
        var receiveAll = buttonElement.getAttribute('data-receive-all');
        this.app.api.private('order_receive', {
            data: {
                uid: uid,
                receive_all: receiveAll
            }
        }).then(function (res) {
            Toast.success(django.gettext('Items received successfully'));
            var backRef = buttonElement.getAttribute('data-back');
            if (backRef) {
                setTimeout(function () {
                    location.href = buttonElement.getAttribute('data-back');
                }, 1000);
            }
            else {
                buttonElement.className = 'button is-success';
                buttonElement.onclick = null;
                buttonElement.removeAttribute('data-item');
                buttonElement.innerHTML = '<i class="fas fa-check"></i>';
            }
        }, function (error) {
            if (error.serverError) {
                Toast.error(error.serverError.error);
            }
            else {
                Toast.error(django.gettext('Unable to recieve the item, please try again'));
            }
            buttonElement.classList.remove('is-loading');
            buttonElement.disabled = false;
        });
    };
    /**
     * OnClick listener for "Receive"-button
     * @param buttonElement "Receive"-button
     */
    OrderDetailView.prototype.onReceivedClick = function (buttonElement) {
        var itemId = buttonElement.getAttribute('data-item');
        var quantityElement = this.el.querySelector("#quantity-".concat(itemId));
        var quantity = parseFloat(quantityElement.value);
        if (isNaN(quantity)) {
            quantityElement.focus();
            return;
        }
        quantityElement.disabled = true;
        buttonElement.disabled = true;
        buttonElement.classList.add('is-loading');
        return this.app.api.public('delivery_item_receive_pub', {
            data: { item_id: itemId, quantity: quantity }
        }).then(function (res) {
            buttonElement.className = 'button is-success';
            buttonElement.onclick = null;
            buttonElement.removeAttribute('data-item');
            buttonElement.innerHTML = '<i class="fas fa-check"></i>';
        }, function (error) {
            buttonElement.classList.remove('is-loading');
            quantityElement.disabled = false;
            buttonElement.disabled = false;
            if (error.serverError) {
                Toast.error(error.serverError.error);
            }
            else {
                Toast.error(django.gettext('Unable to receive the item, please try again'));
            }
        });
    };
    return OrderDetailView;
}(View));
export default OrderDetailView;
